(() => {
// Imaginile de sub banner pornesc abia după ce imaginea bannerului s-a încărcat, apoi pe secțiuni, aproape de ecran.
if (window.feDeferImg) return;
window.feDeferImg = true;
const load = root => root.querySelectorAll('img[data-fe-src]').forEach(img => {
  if (img.dataset.feSrcset) { img.srcset = img.dataset.feSrcset; img.removeAttribute('data-fe-srcset'); }
  img.src = img.dataset.feSrc;
  img.removeAttribute('data-fe-src');
});
const area = img => img.closest('.shopify-section') || img.parentElement;
let observer, started = false;
const scan = () => {
  const areas = new Set();
  document.querySelectorAll('img[data-fe-src]').forEach(img => areas.add(area(img)));
  areas.forEach(el => observer ? observer.observe(el) : load(el));
};
const start = () => {
  if (started) return;
  started = true;
  if (!('IntersectionObserver' in window)) { load(document); return; }
  observer = new IntersectionObserver(entries => entries.forEach(entry => {
    if (!entry.isIntersecting) return;
    observer.unobserve(entry.target);
    load(entry.target);
  }), {rootMargin: '600px 0px'});
  scan();
};
if (window.Shopify && Shopify.designMode) {
  const all = () => load(document);
  document.addEventListener('DOMContentLoaded', all);
  document.addEventListener('shopify:section:load', all);
  all();
  return;
}
const waitHero = () => {
  const img = document.querySelector('[data-fe-v8="hero"] .is-active img') || document.querySelector('[data-fe-v8="hero"] img');
  if (!img || img.complete) { start(); return; }
  img.addEventListener('load', start, {once: true});
  img.addEventListener('error', start, {once: true});
};
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', waitHero); else waitHero();
addEventListener('load', start);
setTimeout(start, 10000);
})();
